import React from 'react'
import _ from 'lodash'
import SkyLight from 'react-skylight'
import ViewStatics from '../ViewStatics/ViewStatics'
import ViewStaticsDouble from '../ViewStatics/ViewStaticsDouble'
import moment from 'moment'
import { Line } from 'react-chartjs'
import * as d3 from 'd3'
import warningData from '../../img/icons/general-icons/icon_warning.png'
import { Sparklines, SparklinesLine, SparklinesReferenceLine } from 'react-sparklines'
// import Charline from './Charline'
const randomDataSet = () => {
  return d3.range(0,100)
}
export default class DashboardMedicalData extends React.Component {
  constructor(props) {
      super(props);
      this.state = { data: randomDataSet() }
    }

  render () {
    var presionParadoAlta = []
    var presionParadoBaja = []
    var presionSentadoAlta = []
    var presionSentadoBaja = []
    var frecuencia = []
    var balanceNeuroMuscular = []
    var peso = []
    var medicalBMIData = []
    var colesterolTotal = []
    var colesterolLDL = []
    var colesterolHDL = []
    var trigliceridos = []
    var creatinina = []
    var glicemia = []
    var control = []
    var fecha = []
    var e = 0

    _.forEach(this.props.data.allobj, (v, i) => {
      e++
      if (i < 6) {
        presionParadoBaja.push(v.presionParadoBaja)
        presionSentadoAlta.push(v.presionSentadoAlta)
        presionSentadoBaja.push(v.presionSentadoBaja)
        frecuencia.push(v.frecuencia)
        balanceNeuroMuscular.push(v.balanceNeuroMuscular)
        peso.push(v.peso)
        medicalBMIData.push(v.peso / (((v.altura /100) * (v.altura /100))))
        colesterolTotal.push(v.colesterolTotal)
        colesterolLDL.push(v.colesterolLDL)
        colesterolHDL.push(v.colesterolHDL)
        trigliceridos.push(v.trigliceridos)
        creatinina.push(v.creatinina)
        glicemia.push(v.glicemia)
        control.push(`Control ${v.control} / ${moment(v.timestamp, 'x').format('DD/MM/YYYY')}`)
        fecha.push()
        fecha.push()

      }
    })
    //  pa = JSON.stringify(pa)
      var settings = {
          backgroundColor: '#1A3B4E',
          color: '#ffffff',
          width: '50%',
          height: 'auto',
          border: '1px solid #FFFFFF',
          fontSize: '14px',
          display: 'flex !important',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
      }

      var chartDataPP = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: presionParadoAlta
          }]
      }
      var chartDataPPB = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: presionParadoBaja
          }]
      }
      var chartDataPS = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: presionSentadoAlta
          }]
      }
      var chartDataPSB = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: presionSentadoBaja
          }]
      }
      var chartDataFC = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: frecuencia
          }]
      }
      var chartDataBN = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: balanceNeuroMuscular
          }]
      }
      var chartDataPeso = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: peso
          }]
      }
      var chartDataBMI = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: medicalBMIData
          }]
      }
      var chartDataCOLT = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: colesterolTotal
          }]
      }
      var chartDataCOLL = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: colesterolLDL
          }]
      }
      var chartDataCOLH = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: colesterolHDL
          }]
      }
      var chartDataCrea = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: creatinina
          }]
      }

      var chartDataTrig = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: trigliceridos
          }]
      }
      var chartDataGlic = {
          labels: control,
          datasets: [{
              fillColor: "rgba(134, 195, 0, 0.2)",
              strokeColor: "rgba(134, 195, 0, 1)",
              pointColor: "rgba(134, 195, 0, 1)",
              data: glicemia
          }]
      }

      var chartOptions = {
          pointDotRadius: 5,
          bezierCurve: false,
          scaleShowVerticalLines: false,
          scaleGridLineColor: "rgba(250,250,250,0.4)",
          pointLabelFontColor: '#EFEFEF', scaleSteps: 8, scaleStepWidth: 2,
          scaleFontColor: '#EFEFEF', scaleLineColor: '#EFEFEF',
          angleLineColor: 'rgba(255,255,255,0.5)', responsive: true,
          scaleBackdropColor: 'rgba(255,255,255,0.75)'
      }

      // console.log('control', control)
      // console.log('control reverse', control.reverse());
      // console.log(d3.range(0,10))
    return (
      <div className='patient-medical-information'>
        <div className='global-medical-container'>
          <div className='medical-name'>P.A Parado</div>
          <div className='medical-data'>{this.props.data.medicalPAParado}</div>
          <div className='medical-icon'>{(this.props.data.medicalData.presionParadoAlta > 220 || this.props.data.medicalData.presionParadoAlta < 90 || this.props.data.medicalData.presionParadoBaja > 120 || this.props.data.medicalData.presionParadoBaja < 60) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.papDialog.show()}>
            <ViewStaticsDouble {...{data:this.props.data.allobj, index:'presionParadoAlta', index2:'presionParadoBaja', media: 120, media2: 80, domain: [0,250]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='papDialog' hideOnOverlayClicked title='Presión arterial parado'>
            <div className="chart-modal-container">
              <ViewStaticsDouble {...{data:this.props.data.allobj, index:'presionParadoAlta', index2:'presionParadoBaja', media: 120, media2: 80, domain: [0,250]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>P.A. Sentado</div>
          <div className='medical-data'>{this.props.data.medicalPASentado}</div>
          <div className='medical-icon'>{(this.props.data.medicalData.presionSentadoAlta > 220 || this.props.data.medicalData.presionSentadoAlta < 90 || this.props.data.medicalData.presionSentadoBaja > 120 || this.props.data.medicalData.presionSentadoBaja < 60) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.pasDialog.show()}>
            <ViewStaticsDouble {...{data:this.props.data.allobj, index:'presionSentadoAlta', index2:'presionSentadoBaja', media: 120, media2: 80, domain: [0,250]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='pasDialog' hideOnOverlayClicked title='Presión arterial sentado'>
            <div className="chart-modal-container">
              <ViewStaticsDouble {...{data:this.props.data.allobj, index:'presionSentadoAlta', index2:'presionSentadoBaja', media: 120, media2: 80, domain: [0,250]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>F.C</div>
          <div className='medical-data'>{this.props.data.medicalFrecuenciaC}</div>
          <div className='medical-icon'>{(this.props.data.medicalFrecuenciaC < 50 || this.props.data.medicalFrecuenciaC > 90) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.fcDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'frecuencia', media: 70, domain: [0,100]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='fcDialog' hideOnOverlayClicked title='Frecuencia cardiaca'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'frecuencia', media: 70, domain: [0,100]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>Balance</div>
          <div className='medical-data'>{this.props.data.medicalBalanceNeur}</div>
          <div className='medical-icon'>{((this.props.data.medicalBalanceNeur) < 10 || (this.props.data.medicalBalanceNeur) > 46) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.bnDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'balanceNeuroMuscularT', media: 20, domain: [0,50]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='bnDialog' hideOnOverlayClicked title='Balance'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'balanceNeuroMuscularT', media: 20, domain: [0,50]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>Peso</div>
          <div className='medical-data'>{this.props.data.medicalPeso}</div>
          <div className='medical-icon'>{(this.props.data.medicalPeso < 50 || this.props.data.medicalPeso > 110) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.pesoDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'peso', media: 70, domain: [0,140]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='pesoDialog' hideOnOverlayClicked title='Peso'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'peso', media: 70, domain: [0,140]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>Col. Total</div>
          <div className='medical-data'>{this.props.data.medicalColTotal}</div>
          <div className='medical-icon'>{(this.props.data.medicalData.colesterolTotal > 600 || this.props.data.medicalData.colesterolTotal < 60) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.totDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'colesterolTotal', media: 180, domain: [0,320]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='totDialog' hideOnOverlayClicked title='Colesterol Total'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'colesterolTotal', media: 180, domain: [0,320]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>Col. LDL</div>
          <div className='medical-data'>{this.props.data.medicalColLDL}</div>
          <div className='medical-icon'>{(this.props.data.medicalData.colesterolLDL > 400 || this.props.data.medicalData.colesterolLDL < 40) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.ldlDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'colesterolLDL', media: 100, domain: [0,190]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='ldlDialog' hideOnOverlayClicked title='Colesterol LDL'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'colesterolLDL', media: 100, domain: [0,190]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>Col. HDL</div>
          <div className='medical-data'>{this.props.data.medicalColHDL}</div>
          <div className='medical-icon'>{(this.props.data.medicalData.colesterolHDL > 120 || this.props.data.medicalData.colesterolHDL < 20) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.ldlDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'colesterolLDL', media: 100, domain: [0,190]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='ldlDialog' hideOnOverlayClicked title='Colesterol LDL'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'colesterolLDL', media: 100, domain: [0,190]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>Trigliceridos</div>
          <div className='medical-data'>{this.props.data.medicalColTrigliceridos}</div>
          <div className='medical-icon'>{(this.props.data.medicalData.trigliceridos > 1200 || this.props.data.medicalData.trigliceridos < 40) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>
          <span onClick={() => this.refs.trigDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'trigliceridos', media: 100, domain: [0,190]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='trigDialog' hideOnOverlayClicked title='Trigliceridos'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'trigliceridos', media: 100, domain: [0,190]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>Creatinina</div>
          <div className='medical-data'>{this.props.data.medicalCreatinina}</div>
          <div className='medical-icon'>{(this.props.data.medicalData.creatinina > 5 || this.props.data.medicalData.creatinina < 0.3) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>

          <span onClick={() => this.refs.creDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'creatinina', media: 1, domain: [-3,3]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='creDialog' hideOnOverlayClicked title='Creatinina'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'creatinina', media: 1, domain: [-3,3]}}/>
            </div>
          </SkyLight>
          </div>
        </div>
        <div className='global-medical-container'>
          <div className='medical-name'>Glicemia</div>
          <div className='medical-data'>{this.props.data.medicalColGlicemia}</div>
          <div className='medical-icon'>{(this.props.data.medicalData.glicemia > 700 || this.props.data.medicalData.glicemia < 40) ? <img src={warningData}/> : null}</div>
          <div className='medical-graph'>

          <span onClick={() => this.refs.gliDialog.show()}>
            <ViewStatics {...{data:this.props.data.allobj, index:'glicemia', media: 100, domain: [0,130]}}/>
          </span>
          <SkyLight dialogStyles={settings} ref='gliDialog' hideOnOverlayClicked title='Glicemia'>
            <div className="chart-modal-container">
              <ViewStatics {...{data:this.props.data.allobj, index:'glicemia', media: 100, domain: [0,130]}}/>
            </div>
          </SkyLight>
          </div>
        </div>

      </div>
    )
  }
}

/* Validate Props */
DashboardMedicalData.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardMedicalData.js